export default __webpack_public_path__ + "static/media/hat.6ef2b6a2.png";